import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useCreateCategoryMutation,
  useGetSocialProfilesLazyQuery,
  useUpdateCategoryMutation
} from '../../../../models/graphql';
import {
  CreateEditCategoryModalController,
  CreateEditCategoryModalControllerProps
} from './CreateEditCategoryModal.controller';

export type CreateEditCategoryModalApolloProps = Omit<
  CreateEditCategoryModalControllerProps,
  'createCategory' | 'updateCategory' | 'getCategory' | 'categoryResults' | 'getProfiles' | 'profilesResults'
> & {
  // ...
};

gql`
  query GetCategory($categoryId: ID!) {
    category(categoryId: $categoryId) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }

  mutation CreateCategory($workspaceId: ID!, $input: CreateCategoryInput!) {
    createCategory(workspaceId: $workspaceId, input: $input) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      color
      onboardingContent
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }

  mutation UpdateCategory($categoryId: ID!, $input: UpdateCategoryInput!) {
    updateCategory(categoryId: $categoryId, input: $input) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      color
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }
`;

export const CreateEditCategoryModalApollo = (props: CreateEditCategoryModalApolloProps): JSX.Element => {
  const [getProfiles, profilesResults] = useGetSocialProfilesLazyQuery();
  const [createCategory] = useCreateCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();

  const controllerProps: CreateEditCategoryModalControllerProps = {
    ...props,
    createCategory,
    updateCategory,
    getProfiles,
    profilesResults
  };

  return <CreateEditCategoryModalController {...controllerProps} />;
};
